import { SpaceXxs, ColorCostcoRed, ColorGray900 } from "@nxt-costco-com/forge-design-tokens";
const memberOnlyContainerStyles = {
  alignItems: "center",
  cursor: "pointer",
  display: "flex",
  flexDirection: "row",
  gap: SpaceXxs,
  width: "fit-content"
};
const memberOnlyIconStyles = {
  color: ColorCostcoRed,
  height: 14,
  width: 14
};
const memberOnlyTextStyles = {
  color: ColorGray900
};
export {
  memberOnlyContainerStyles,
  memberOnlyIconStyles,
  memberOnlyTextStyles
};
